module.exports = __webpack_public_path__ + "/dist/assets/fonts/fa-solid-900.eot";